"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var lodash_1 = require("lodash");
var operators_1 = require("rxjs/operators");
var properties_utilities_1 = require("../properties.utilities");
exports.SERVICE_URLS_URL = new core_1.InjectionToken('Url of Urls');
var logger = properties_utilities_1.createLogger('properties-service');
var PropertyService = /** @class */ (function () {
    function PropertyService(httpClient, propertyPath) {
        this.httpClient = httpClient;
        this.propertyPath = lodash_1.isNil(propertyPath)
            ? 'properties/urls'
            : propertyPath;
    }
    PropertyService.prototype.loadProperties = function () {
        logger.debug('loading properties from %s', this.propertyPath);
        return this.httpClient
            .get(this.propertyPath, {
            headers: { 'Access-Control-Allow-Origin': '*' },
        })
            .pipe(operators_1.tap(function () { return logger.debug('successfully loaded properties'); }, function (e) {
            return logger.error('error occurred while loading properties %O', e);
        }));
    };
    PropertyService = __decorate([
        core_1.Injectable(),
        __param(1, core_1.Inject(exports.SERVICE_URLS_URL)),
        __param(1, core_1.Optional()),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], PropertyService);
    return PropertyService;
}());
exports.PropertyService = PropertyService;
//# sourceMappingURL=property.service.js.map